import React from 'react';
import Icon, { IconProps } from './Icon';

const ArrowNarrowLeftIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M20 12H4M4 12L10 18M4 12L10 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default ArrowNarrowLeftIcon;

